import { Link } from 'react-router-dom';

interface Cast {
  name: string;
  role: string;
}

interface Props {
  cast: Cast[];
  director: string;
  writers: string[];
}

export default function CastSection({ cast, director, writers }: Props) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="flex items-center gap-1.5 font-heading text-base font-bold text-foreground-950">
        <i className="ri-group-line text-foreground-500 w-4 h-4 flex items-center justify-center" />
        演职员信息
      </h2>
      <ul className="mt-3.5 grid grid-cols-2 gap-2.5 sm:grid-cols-3">
        {cast.map((member) => (
          <li
            key={member.name}
            className="flex items-center gap-2.5 rounded-md bg-background-100 px-2.5 py-2"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
              {member.name.slice(0, 1)}
            </span>
            <span className="min-w-0">
              <span className="block truncate text-[13px] font-medium text-foreground-950">
                {member.name}
              </span>
              <span className="mt-0.5 block truncate font-label text-[10px] text-foreground-500">
                饰 {member.role}
              </span>
            </span>
          </li>
        ))}
      </ul>
      <div className="mt-3.5 grid grid-cols-1 gap-2 border-t border-background-200 pt-3.5 sm:grid-cols-2">
        <p className="text-xs text-foreground-600">
          <span className="mr-2 text-foreground-400">导演</span>
          <span className="font-medium text-foreground-900">{director}</span>
        </p>
        <p className="text-xs text-foreground-600">
          <span className="mr-2 text-foreground-400">编剧</span>
          <span className="font-medium text-foreground-900">{writers.join(' / ')}</span>
        </p>
      </div>
    </section>
  );
}